module.exports = __webpack_public_path__ + "img/mingren.f77a2408.jpg";